import type { InjectionKey } from 'vue';
import type { CloudinaryHelper } from './plugins/cloudinary';
import type { VueAuth0InstanceType } from './plugins/auth';
import type { ModalType } from './plugins/modal';
import type { LoggerType } from './plugins/logger';
import type { RudderstackType } from './plugins/rudderstack';
import type { SentryType } from './plugins/sentry';
import type { GtmType } from '@/ui/plugins/gtm';

export const authKey: InjectionKey<VueAuth0InstanceType> = Symbol('auth');
export const cloudinaryKey: InjectionKey<CloudinaryHelper> = Symbol('cloudinary');
export const loggerKey: InjectionKey<LoggerType> = Symbol('logger');
export const modalKey: InjectionKey<ModalType> = Symbol('modal');
export const rudderstackKey: InjectionKey<RudderstackType> = Symbol('rudderstack');
export const sentryKey: InjectionKey<SentryType> = Symbol('sentry');
export const gtmKey: InjectionKey<GtmType> = Symbol('gtm');
